<template>
  <div class="main">
    <div class="left">
      <div class="left-t">
        <el-form :model="formInline" class="demo-form-inline">
          <el-form-item>
            <el-input
              v-model="formInline.user"
              placeholder="请输入联系人名称搜索"
            >
            <el-button slot="append" icon="el-icon-search"  @click="onSearch"></el-button>

          </el-input>
          </el-form-item>
         
        </el-form>
      </div>
      <div class="left-b">
        <ul>

          <user-item
              v-for="(item, index) in pageProps.records"
              @selectItem="selectCustomer"
              :key="index"
              :index="index"
              :avatar="item.log_img"
              :name="item.name"
              :time="item.message_time"
              :content="item.content"
              :active="chatIndex==index"
              :unread="item.unread_num"

            >
            </user-item>

        </ul>
      </div>
    </div>
    <div class="medile" v-if="chatItem.cus_id">
      <div class="top_1">
        <img :src="chatItem.log_img" />
        <span>{{chatItem.name}}</span>
      </div>
      <div class="con" id="msgBox">
       <!-- <p>12-06 10:30</p>-->
        <div >
          <msg-item  
            v-for="(item,index) in messageList"
            :key="index" 
            :user_avatar="item.user_avatar"
            :receive_avatar="item.receive_avatar"
            :isSend="item.status"
            :type="item.type"
            :value_field="item.value_field+''"
            :value_id="item.value_id+''"
            :content="item.content"
            :send_user_id="item.send_user_id+''"
            :receive_user_id="item.receive_user_id+''"
            :type_str="item.type_str?type_str:''"
            > 
          </msg-item>
        </div>
      </div>
      <div class="under">
        <div>
          <header style="display:flex;align-self:center">
                <Emoji :textAreaId="'msgContent'">
                 <button style="background: transparent;border: unset;"><img src="@/assets/chat-img/bq.png" alt="表情" style="width:25px;height:25px"  /></button>
                </Emoji>
              </header>
        </div>
        <p>
          <el-input
            id="msgContent"
            type="textarea"
            resize="none"
            rows="5"
            class="msginput"
            placeholder="按下回车键发送消息"
            v-model="content"
            @keyup.enter.native="sendTxtMsg(1)"

          >
          </el-input>
          <el-button type="primary" round @click="sendTxtMsg(1)">发送</el-button>
        </p>
      </div>
    </div>
    <div v-else class="medile" style=" justify-content: center; align-items: center;align-self: center;" >
      <el-empty description="暂无聊天消息"></el-empty>
    </div>
    <div class="right">
      <h3>常见问题</h3>
      <ul>
        <li><a href="#">如何发布职位？</a></li>
        <li><a href="#">客服电话是什么？</a></li>
        <li><a href="#">发布职位要收费吗？</a></li>
        <li><a href="#">主管端如何编辑企业主页内容？</a></li>
      </ul>
    </div>
  </div>
</template>

<script>
import { chatList,messagelist,customerList,customerMessageList,customerShare} from "@/api/chat/index";
//import dafaultImg from '@/assets/chat-img/img1.png'
import Emoji from "@/components/Emoji/Emoji.vue";
import { mapGetters } from 'vuex'
import msgItem from "@/components/chat/msg-item.vue";
import userItem from "@/components/chat/user-item.vue";

export default {
  components: {Emoji,msgItem,userItem
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'isLogin',
      'user_type'// 1 求职 2 招聘
    ]),
  },

  data() {
    return {
      formInline: {
        user: "",
      },
      chatIndex:-1,
      content:"",
      pageProps: {
          records:[],
          total: 0,
          limit: 10,
          page: 1
        },
       chatItem:{
        cus_id:''
       }, 
       user_app_id:"",

       messageList:[],
     
    };
  },
  mounted(){
    this.fetchList();
  },
  methods: {

    onSearch(){
      this.fetchList();

    },

    fetchList(){
      var that = this;
      var params={
        page:that.pageProps.page,
        limit:that.pageProps.limit,
      }

      customerList(params).then((response) => {
        that.pageProps.records = response.data.data;
        that.pageProps.total = response.data.total;
      });
    },

    selectCustomer(index){
      var that = this;
      that.chatIndex=index;
      that.chatItem=that.pageProps.records[index];
      that.pageProps.records[index].unread_num=0;
      var params={
        cus_id:that.chatItem.cus_id,
      }

      customerShare(params).then((response) => {
        if(response.code==200){
          var user_app_id=response.user_app_id;
          that.user_app_id=user_app_id;
          
          var link=3;
          that.ws.initWebSocket(
            that.wsUrl
          +"?send_user_id="+that.userInfo.user_app_id
          +"&receive_user_id="+that.user_app_id
          +"&link="+link
          +"&cus_id="+that.chatItem.cus_id);
          if(that.ws.websocket){
            that.ws.websocket.onmessage = function(messageEvent){
              console.log("消息====",messageEvent);
              console.log("消息=that.chatItem.cus_id===",that.chatItem.cus_id);
              that.fetchChatMsgList(that.chatItem.cus_id);
            }
          }
          that.fetchChatMsgList(that.chatItem.cus_id);
        }else{
          that.$message.error(response.msg?response.msg:"分配客服失败");
        } 
       
      });


    

    },


    fetchChatMsgList(cus_id){

      var that = this;
      //type	是	int	1招聘列表2好友列表3未读列表
      //page	否	int	页数
      //limit	否	int	每页条数
      var params={
        "cus_id":cus_id
      }

      customerMessageList(params).then((response) => {
        if(response.code==200){
          var datas= response.data;
          var receive_avatar=response.receive_avatar;
          var user_avatar=response.user_avatar;
          //
          for (let item of datas) {
           
            item.receive_avatar=receive_avatar;//
            item.user_avatar=user_avatar;//
          }
          that.messageList=datas;
          this.scrollBottom();
        }

      });

    },
    scrollBottom(){
      this.$nextTick(() => {
        var dom = document.getElementById('msgBox');

        dom.scrollTop = dom.scrollHeight;
     })
    },



    sendTxtMsg(){
      var msgContent=document.getElementById('msgContent');
      this.content=msgContent.value;
      this.sendMsg(1,this.content,'','','','','','');
    },


    //发送消息
    /*
    type 消息类型，1文字消息，6申请查看简历，9发送红包，10同意查看简历，11拒绝查看简历，12邀请面试，13主动发送简历，
      //16图片，17位置，18邀请入职，19签署合同

    value_id	是	int	红包id，邀请面试id等
    value_field	是	int	图片地址，位置信息
    lat	是	int	经度
    lng	是	int	纬度
    link	是	int	1好友消息，2求职消息，3客服消息
    cus_id	否	int	客服id
    job_id	否	int	职位id，求职消息时发送
    */
    sendMsg(type,content='',value_id='',value_field='',lat='',lng='',cus_id='',job_id='') {
       //
       var that=this;
      var link=3;
     

      if(this.ws.websocket){
        var obj = {
          send_user_id:that.userInfo.user_app_id,
          receive_user_id:that.user_app_id,
          link:link,
          type:type,
          content:type==1?content:'',
          value_id:value_id,
          value_field:value_field,
          lat:lat,
          lng:lng,
          cus_id:that.chatItem.cus_id,
        }
          var last = JSON.stringify(obj);
          console.log("last",last);
          that.ws.websocket.send(last);
          if(type==1){
            that.content="";
          }
          this.fetchChatMsgList(that.chatItem.cus_id);
        }
    },


    onSubmit() {
      console.log("submit!");
    },
    
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-textarea__inner {
  border: none;
  resize: none;
}
.main {
  // width: 1200px;
  display: flex;
}
.left {
  width: 316px;
}

.left-t {
  height: 29px;
  margin-top: 29px;
  margin-left: 13px;
  margin-bottom: 11px;
}
.left-b ul {
  height: 576px;
  overflow-x: hidden;
  overflow-y: scroll;
}

.left-b ul::-webkit-scrollbar {
  /*滚动条整体样式*/
  // width: 1px;
  /*高宽分别对应横竖滚动条的尺寸*/
  // height: 1px;
  width: 1px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.medile {
  width: 659px;
  // display: flex;
  // flex-wrap: wrap;
}
.top_1 {
  height: 72px;
  background-color: #f3f3f3;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.16);
  padding-left: 25px;
  display: flex;
  align-items: center;
}
.top_1 img {
  width: 43px;
  height: 43px;
  border-radius: 50%;
  margin-right: 10px;
}
.top_1 span {
  font-size: 16px;
  color: #333333;
}
.con {
  width: 659px;
  height: 418px;
  padding: 20px;
  box-sizing: border-box;
  overflow-y: auto;
}


.under {
  display: flex;
  // width: 659px;
  //height: 158px;
  border-top: 1px solid #cccccc;
  flex-direction: column;
}
.under > div {
  padding: 10px 10px 0;
}
.under div img {
  width: 30px;
  height: 30px;
}
.under p {
  padding: 10px;
  display: flex;
  align-items: flex-end;
}
.right {
  width: 225px;
  box-sizing: border-box;
  padding: 20px;
  border-left: 1px solid #cccccc;
}
.right a {
  color: #4c71db;
  font-size: 13px;
  line-height: 40px;
}
.right h3 {
  font-size: 16px;
  line-height: 60px;
  text-align: center;
}




</style>>